var useragent = (function () {
    var standalone = window.navigator.standalone,
        userAgent = window.navigator.userAgent.toLowerCase(),
        safari = /safari/.test(userAgent),
        ios = /iphone|ipod|ipad/.test(userAgent);

    var isSafariMobile = function () {
        return ios && !standalone && safari;
    };

    var isiOS = function () {
        return ios;
    };

    return {
        isSafariMobile: isSafariMobile,
        isiOS: isiOS
    };
})();